import React from "react";

export default function TransitionContainer({ isInitialLoading, isFetchingNext, children, skeleton }) {
  if (isInitialLoading) {
    return (
      <div style={{ padding: "20px", marginTop: "20px", opacity: 0.5, transition: "opacity 200ms ease" }}>
        {skeleton ? (
          skeleton
        ) : (
          <>
            <div style={{ width: 240, height: 24, background: "rgba(0,0,0,0.06)", borderRadius: 6 }} />
            <div style={{ marginTop: 20, width: "100%", height: 280, background: "rgba(0,0,0,0.05)", borderRadius: 12 }} />
            <div style={{ marginTop: 24, height: 36, width: "100%", background: "rgba(0,0,0,0.04)", borderRadius: 8 }} />
          </>
        )}
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", marginTop: "20px", opacity: isFetchingNext ? 0.5 : 1, transition: "opacity 200ms ease" }}>
      {children}
    </div>
  );
}


